import React from "react";
import { CommandBlock } from "../common/Commands2";

export default function Page() {
  return (
    <>
      <h1>Systems Sync</h1>

      <p className="print-hide">
        Synchronises cached systems list with MYOB. If you have changed
        something directly in MYOB and it is not showing up in one of the
        systems, you can run this manually.
      </p>

      <CommandBlock endpoint="/command/sync-systems" enabled schedule />
    </>
  );
}
